/**
 * User-facing lens names (API still uses `bds` filter key).
 * Describes what we check — occupation/settlement list evidence, not a region filter.
 */
export const LENS_LABELS = {
  /** Toggle + table column */
  occupation: 'Occupation & settlements',
  occupationShort: 'Occupation',
  occupationSub:
    'BDS-style lists: settlement links, occupied land, supply chains (AFSC, Who Profits, OHCHR A/HRC/60/19). Not all companies tied to a region.',
  occupationEvidence: 'Occupation & settlements',
  occupationSources: 'Occupation & settlements',
  defense: 'Defense contractors',
  defenseShort: 'Defense',
  shariah: 'Shariah compliance',
  shariahShort: 'Shariah',
  /** Occupation column — plain language (not “Clean”) */
  occupationNotFlagged: 'Not flagged',
  occupationFlagged: 'Flagged',
  occupationNeedsReview: 'Needs review',
  /** Shown under results when occupation lens is on */
  occupationResultsFootnote:
    'Occupation screening checks public research on company ties to occupation and settlements (Investigate / Who Profits / OHCHR). Not flagged means we found no entry — not an all-clear, and not every boycott app’s campaign list.',
  occupationNoMatchDetail:
    'No occupation or settlement concerns found in our database for this company. This is not an all-clear — we only check documented research, not every boycott campaign.',
  occupationCheckedSources: 'Checked: Investigate (AFSC) · Who Profits · OHCHR A/HRC/60/19',
} as const;
